require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-i-s-ird.json") })
        }
      }, "path---photos-professional-i-s-ird");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-i-s-ird!./.cache/json/photos-professional-i-s-ird.json
// module id = 776
// module chunks = 231608221292675